// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvUpload-FooterButton_cls1__d6zf3","cls2":"GroupCsvUpload-FooterButton_cls2__sZuLN GroupCsvUpload-FooterButton_cls1__d6zf3"};